import { GridRowClassNameParams, GridRowSelectionModel } from '@mui/x-data-grid-premium'
import { OrganizationTableItem } from 'types/organizations_table'

export const getDealRowClassNames = (
  params: GridRowClassNameParams,
  rowSelectionModel: GridRowSelectionModel,
  selectedDeal?: OrganizationTableItem | null
) => {
  const classes: string[] = []

  const rowDealUuid = params?.row?.deal_uuid as string | undefined
  // highlight predecessor/successor of the *selected deal*
  if (Array.from(rowSelectionModel?.ids)?.length === 1) {
    if (selectedDeal && rowDealUuid) {
      const predecessor = selectedDeal.predecessorId
      const successor = selectedDeal.successorId

      if (predecessor && rowDealUuid === predecessor && selectedDeal.deal_uuid !== predecessor) {
        classes.push('highlight-predecessor')
      }
      if (successor && rowDealUuid === successor && selectedDeal.deal_uuid !== successor) {
        classes.push('highlight-successor')
      }
    }
  }

  // existing warning logic
  // if (
  //   params?.row?.daysLeft > 0 &&
  //   params?.row?.daysLeft <= 30 &&
  //   ['Active', 'Pending'].includes(params?.row?.dealStatus) &&
  //   params?.row?.stage === 'Deal Won' &&
  //   params?.row?.status !== 'Completed Internally'
  // ) {
  //   classes.push('deal-row-warning')
  // }

  if (params?.row?.isClone) classes.push('highlight-clone-deal')
  if (params?.row?.isCreative) classes.push('creative-row-border')
  if (params?.row?.isMarketing) classes.push('marketing-row-border')
  if (params?.row?.isWebsite) classes.push('website-row-border')
  if (params?.row?.highPrio) classes.push('high-priority-row')
  if (params?.row?.isSubtask) classes.push('subtask-row')

  return classes.join(' ')
}
